import { render, staticRenderFns, recyclableRender, components } from "./u-car-keyboard.vue?vue&type=template&id=3fcafe27&scoped=true&"
var renderjs
import script from "./u-car-keyboard.vue?vue&type=script&lang=js&"
export * from "./u-car-keyboard.vue?vue&type=script&lang=js&"
import style0 from "./u-car-keyboard.vue?vue&type=style&index=0&id=3fcafe27&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcafe27",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "node_modules/uview-ui/components/u-car-keyboard/u-car-keyboard.vue"
export default component.exports